export interface ProductsFeatureRoutesConfig {
  path: string;
}

export const defaultProductsFeatureRoutesConfig: ProductsFeatureRoutesConfig = {
  path: 'products',
};
